import type { FieldReadFunction } from '@apollo/client';

import { DateAdapter } from '@myphx-engineering/date-utils/client';

import { getInitialsFromFullName } from '../util';

export const readFullName: FieldReadFunction = (_, { readField }) => {
    const firstName = readField<string>('firstName');
    const lastName = readField<string>('lastName');
    return [firstName, lastName].filter((x) => x).join(' ');
};

export const readPatientInitials: FieldReadFunction = (_, { readField }) => {
    const fullName = readField<string>('fullName');
    return getInitialsFromFullName(fullName);
};

export const readPatientAge: FieldReadFunction = (_, { readField }) => {
    const dob = readField<string>('dateOfBirth')!;
    return DateAdapter.getAgeFromInput(dob);
};

export const patientDetails = {
    fullName: {
        read: readFullName,
    },
    initials: {
        read: readPatientInitials,
    },
    age: {
        read: readPatientAge,
    },
};
